import { useState } from "react";
import SectionHead from "./SectionHead";

const TOPICS = [
  {
    q: "「先入为主」真的会影响我们对一个人的判断吗？",
    sideA: "会，越早看到的越难推翻，之后需要更多证据才能翻盘。",
    sideB: "不会，关键证据出现后，多数人依然愿意改变看法。",
    tag: "讨论热度 #1",
  },
  {
    q: "剪辑到底该「还原真实」还是「服务好看」？",
    sideA: "真人秀的前提是真实，任何取舍都该向观众交代清楚。",
    sideB: "节目本质是内容产品，好看优先，真实得为叙事让步。",
    tag: "争议最集中",
  },
  {
    q: "道歉之后，信任还能重建吗？",
    sideA: "诚意的道歉 + 实际行动，是可以慢慢把信任找回来的。",
    sideB: "信任一旦裂了就很难修复，下一次同样的事情还会发生。",
    tag: "观点两极",
  },
  {
    q: "下一季换了玩法，你还会追吗？",
    sideA: "会，彩蛋埋得太香了，新的坑已经吊足胃口。",
    sideB: "要看第一集口碑，被伤过一次的观众会先观望。",
    tag: "收尾讨论中",
  },
];

const POLL_OPTIONS = ["非常满意，收尾漂亮", "整体还行，结尾略仓促", "一般般，没达到预期", "不满意，心里还有疙瘩"];

export default function Topics() {
  const [counts, setCounts] = useState<number[]>([421, 306, 158, 96]);
  const [picked, setPicked] = useState<number | null>(null);

  const total = counts.reduce((a, b) => a + b, 0);
  const pct = (n: number) => (total === 0 ? 0 : Math.round((n / total) * 100));

  const handlePick = (idx: number) => {
    if (picked === idx) return;
    setCounts((prev) => {
      const next = [...prev];
      next[idx] += 1;
      return next;
    });
    setPicked(idx);
  };

  return (
    <section id="topics" className="scroll-mt-20 border-y border-background-200 bg-background-100/60 py-14 md:py-20">
      <div className="page-shell">
        <SectionHead
          kicker="收尾讨论区"
          title="大结局之后，大家还在吵什么"
          desc="结局已定，讨论未散。下面是收尾阶段最集中、也最真实的几组讨论，欢迎也来投出你的一票。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 lg:grid-cols-5">
          {/* interactive poll */}
          <div className="rounded-2xl border border-background-200 bg-background-50 p-6 lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-bar-chart-2-line" aria-hidden="true" />
              </span>
              <div>
                <p className="text-xs font-bold text-primary-500">发起一个小投票</p>
                <h3 className="text-sm font-black text-foreground-950">这期 88大结局，你打几分？</h3>
              </div>
            </div>

            <ul className="mt-5 space-y-3">
              {POLL_OPTIONS.map((opt, idx) => {
                const active = picked === idx;
                const width = pct(counts[idx]);
                return (
                  <li key={opt}>
                    <button
                      type="button"
                      onClick={() => handlePick(idx)}
                      className={`relative w-full overflow-hidden rounded-xl border px-4 py-3 text-left transition-colors ${
                        active
                          ? "border-primary-400 bg-primary-100/60"
                          : "border-background-200 bg-background-100/50 hover:border-primary-200"
                      }`}
                    >
                      <span
                        className="absolute inset-y-0 left-0 bg-accent-200/70 transition-all duration-500"
                        style={{ width: `${active ? width : width * 0.6}%` }}
                        aria-hidden="true"
                      />
                      <span className="relative flex items-center justify-between gap-3">
                        <span className="text-sm font-semibold text-foreground-900">{opt}</span>
                        <span className="text-sm font-black text-foreground-950">{pct(counts[idx])}%</span>
                      </span>
                    </button>
                  </li>
                );
              })}
            </ul>

            <p className="mt-4 text-xs text-foreground-600">
              <i className="ri-check-double-line mr-1 text-primary-500" aria-hidden="true" />
              {picked !== null
                ? "感谢站队！你的选择已计入统计。"
                : `已有 ${total} 位瓜友参与，点一下任意选项即可站队。`}
            </p>
          </div>

          {/* discussion topic cards */}
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:col-span-3">
            {TOPICS.map((t) => (
              <article
                key={t.q}
                className="flex flex-col rounded-2xl border border-background-200 bg-background-50 p-5"
              >
                <div className="flex items-center justify-between gap-2">
                  <span className="chip bg-accent-100 px-2.5 py-0.5 text-xs font-bold text-accent-800">
                    {t.tag}
                  </span>
                </div>
                <h3 className="mt-3 text-sm font-black leading-snug text-foreground-950 md:text-base">
                  {t.q}
                </h3>
                <div className="mt-3 space-y-2">
                  <div className="rounded-lg bg-secondary-100/70 px-3 py-2 text-xs leading-relaxed text-foreground-800">
                    <span className="mr-1 font-black text-primary-600">正方</span>
                    {t.sideA}
                  </div>
                  <div className="rounded-lg bg-secondary-100/70 px-3 py-2 text-xs leading-relaxed text-foreground-800">
                    <span className="mr-1 font-black text-accent-700">反方</span>
                    {t.sideB}
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}